import styled from 'styled-components';

export const Container = styled.div`
  .img-logos {
    max-width: 100%;

    @media only screen and (max-width: 768px) {
      max-height: 80px !important;
    }
  }
`;
